let imageDimensions = {};

function addImageDimension(name, label, retX, retY) {
    imageDimensions[name] = {
        name: name,
        label: label,
        retina: {x: retX, y: retY},
        regular: {
            x: retX ? retX/2 : null,
            y: retY ? retY/2 : null
        }
    }
}

addImageDimension("__GIF__", "GIF", null, null);

// Winner Images
addImageDimension("winnerUser", "Winner User", 600, 600);

// Prize Images
addImageDimension("sweepsPrize", "Sweeps Prize", 640, 310);

// Rewards Images
addImageDimension("retailerItemImage", "Retailer Item", null, null);

// Challenge Level
addImageDimension("cardTrending", "Card Trending", 980, 500);
addImageDimension("heroCard", "Hero Card", 1200, 720);
addImageDimension("featured", "Featured", 640, 500);
addImageDimension("socialShare", "Social Share", 1200, 628);
addImageDimension("socialSharePinterest", "Social Share Pinterest", 1470, 2204);

// 2020 homepage layout
addImageDimension("heroCard2020", "Hero Card 2020", 1200, 542); // 2.2 ratio
addImageDimension("tile2020", "Tile 2020", 640, 338);
addImageDimension("header2020", "Header 2020", 1440, 380);


// New Intro Section Images
addImageDimension("introImage", "Intro Image", 2560, 1920); // TODO: Real image dimensions
addImageDimension("logoImage", "Logo", 400, 400);
addImageDimension("introSideImage", "Intro Side Image", 440, 440);
addImageDimension("introHeaderImage", "Intro Header Image", 2226, 208);

addImageDimension("stepBackgroundImage", "Step Background Image", 2560, 1600);

// Experience Map
addImageDimension("clientLogo", "Client Logo", 306, 250);
addImageDimension("mapImage", "Map Image", 640, 500);
addImageDimension("mobileMapHeader", "Map Header Image", 760, 487);
addImageDimension("mapHeadlineImage", "Map Headline Image", 2000, 336);
addImageDimension("mapHeadlineImage2020", "Map Headline Image", 1700, null);
addImageDimension("backgroundWrapper", "Background Wrapper", 4000, 2000);

// Filtering step
addImageDimension("filteringResult", "Filtering Result", 664, 496);

// Personality
addImageDimension("personalityQuestion", "Personality Question", 1490, 454);
addImageDimension("personalityAnswer", "Personality Answer", 716, 426);
addImageDimension("personalityResult", "Personality Result", 1490, 816);
addImageDimension("personalityBranded", "Personality Branded", 422, 278);

// Personality Shopping List
addImageDimension("shoppingListVertical", "Shopping List Vertical", 542, 542);
addImageDimension("shoppingListHorizontal", "Shopping List Horizontal", 542, 430);

// Step Header
addImageDimension("stepHeaderImage", "Step Header", 1490, 614);

// Facebook Comment
addImageDimension("facebookComment", "Facebook Comment", 1490, 454);

// Referral/Rewards
addImageDimension("referralReward", "Referral/Reward", 1490, 756);
addImageDimension("referralHeader", "Referral Header", 1490, 756);
addImageDimension("referralTwoColumn", "Referral Two Column", 730, 760);
addImageDimension("referralThreeColumn", "Referral Three Column", 476, 760);

addImageDimension("referral3x2", "Referral Header", 600, 400);  // 3:2 - 3 wide x 2 tall


// LeadGen
addImageDimension("leadGen", "LeadGen", 1490, 816);

// Complete
addImageDimension("complete", "Complete", 1356, 512);

// Listicle
addImageDimension("listicle", "Listicle (Old)", 1510, 800);
addImageDimension("listicleHorizontal", "Listicle Horizontal", 1490, 800);
addImageDimension("listicleVertical", "Listicle Vertical", 800, 1490);
addImageDimension("listicleHeader", "Listicle Header", 1490, 614);
addImageDimension("listicleFlexibleHeight", "Listicle Flexible Height", 1490, null);
addImageDimension("listicleImageComparison", "Listicle Image Comparison", 1490, 994);

// Trivia
addImageDimension("triviaQuestion", "Trivia Question", 1490, 614);
addImageDimension("triviaAnsweredImage", "Trivia Question", 1490, 614);
addImageDimension("triviaAnswer", "Trivia Answer", 732, 400);
addImageDimension("triviaResult", "Trivia Result", 1490, 816);
addImageDimension("triviaResultShare", "Trivia Result Share", 1200, 628);

// Poll
addImageDimension("pollQuestion", "Poll Question", (440 * 2), (250 * 2));
addImageDimension("pollAnswer", "Poll Answer", 732, 400);
addImageDimension("pollAnswerImageOptions", "Poll Answer Image Options", 260, 320);
addImageDimension("pollSocialShare", "Poll Social Share", 1200, 628);
addImageDimension("pollQuestion2020", "Poll Question", (440 * 2), (250 * 2));
addImageDimension("pollAnswerImageOptions2020", "Poll Answer", (357 * 2), (195 * 2));

// MemoryMatch
addImageDimension("memoryMatchCard", "Memory Match Card", 300, 300);

// Spot the Difference
addImageDimension("spotDif", "Spot the Difference", 1200, 800);
addImageDimension("spotDiffExampleImage", "Spot The Difference Example", 1300, 682);

// Puzzle
addImageDimension("puzzle", "Puzzle", 2400, 1800);

// Drag and Drop
addImageDimension("dragDrop", "Drag and Drop", 600, 600);
addImageDimension("dragDropPuzzleExample", "Puzzle Example Image", 300, 230);
addImageDimension("dragDropCardImage", "Drag and Drop Card Image", 600, 600);

// UGC
addImageDimension("ugcNoteCardExample", "UGC Note Card Example", 1300, 682);
addImageDimension("ugcNoteCardTemplate", "UGC Note Card Template", 1300, 682);
addImageDimension("ugcFaceInHoleExample", "UGC Face In Hole Example", 1300, 682);
addImageDimension("ugcFaceInHoleOption", "UGC Face In Hole Option", 1300, 682);
addImageDimension("ugcPhotoUploadExample", "UGC Photo Upload Example", 1300, 682);
addImageDimension("ugcPhotoUploadOption", "UGC Photo Upload Option", 1300, 682);
addImageDimension("ugcPhotoUploadOption2020", "UGC Photo Upload Option", 750, 750);

//CheckList
addImageDimension("checkListHalf", "Checklist Half", 730, 392);
addImageDimension("checkListFull", "Checklist Full", 1490, 614);

//Grocery Checklist
addImageDimension("grocerySquare", "Grocery Checklist Square", (160 * 2), (160 * 2));
addImageDimension("groceryVertical", "Grocery Checklist Vertical", (200 * 2), (270 * 2));
addImageDimension("groceryHorizontal", "Grocery Checklist Horizontal", (300 * 2), (160 * 2));


// Receipt
addImageDimension("receiptHeader", "Receipt Header", 1490, 624);
addImageDimension("receiptDetailInstruction", "Receipt Detail Instruction", 100, 100);

// Store Finder
addImageDimension("customMapIcon", "Custom Map Icon", 32, 32);

// Content
addImageDimension("menuContentIcon", "Menu Icon", 50, 50);

addImageDimension("custom", "Custom", null, null);

export const GIFType = "__GIF__";

export default imageDimensions;



// WEBPACK FOOTER //
// ./public/utils/ImageDimensions.js